// this file is automatically generated by git.version.ts script
export const versions = {revision: '15aaf5f56'};